import React, { useState, useEffect} from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';
import CreateIcon from '@material-ui/icons/Create';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 75,
    left: 60,
  },
  paper: {
    padding: '2px 2px',
    display: 'flex',
    alignItems: 'center',
    width: 48,
  },
  margin: {
    margin: theme.spacing(1),
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  layerButton: {
    backgroundColor: '#0C4C35',
    '&:hover': {
      backgroundColor: '#63D764'
    },
    '&.MuiToggleButton-root.Mui-selected': {
      backgroundColor: '#63D764',
      color: '#FFFFFF',
    },
    color: '#FFFFFF',
    width: 42,
    height: 42,
  }
}));

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);


export default function MapToolsPaper(props) {

  const classes = useStyles();
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {

    props.handleChange();
    setIsActive(!isActive);
  };

  return (
    <div className={classes.paper}>
        <HtmlTooltip title={<React.Fragment>{props.tooltip}</React.Fragment>}>
          <span>
          <ToggleButton className={classes.layerButton} value="draw" disabled={props.disabled} selected={props.selected} onChange={() => { handleClick() } }> <CreateIcon fontSize="small"/></ToggleButton>
          </span>
        </HtmlTooltip> 
    </div>
  );
}